import { Days, GenderType, MinDays } from "./types";
import dayjs, { Dayjs } from "dayjs";

export const periodToDays = (years: number, months: number) => {
  return Math.floor((years + months / 12) * 365);
};

export const pastDate = (years: number, months: number): Dayjs => {
  return dayjs(new Date()).subtract(years, "year").subtract(months, "month");
};

export const dateDiff = (date1: Date, date2: Date): Days => {
  const firstDate = dayjs(date1);
  const secondDate = dayjs(date2);

  if (firstDate.isAfter(secondDate)) return firstDate.diff(secondDate, "day");
  return 0;
};


export const getPoints = (gender: GenderType, currentYear: number): number => {
  if (currentYear < 2020) return gender === "male" ?  35040 : 31404;
  else if (currentYear < 2021) return gender === "male" ?  35405 : 31769;
  else if (currentYear < 2022) return gender === "male" ?  35860 : 32134;
  else if (currentYear < 2023) return gender === "male" ?  36225 : 32499;
  else if (currentYear < 2024) return gender === "male" ?  36590 : 32864;
  else if (currentYear < 2025) return gender === "male" ?  36955 : 33229;
  else if (currentYear < 2026) return gender === "male" ?  37320 : 33594;
  else if (currentYear < 2027) return gender === "male" ?  37685 : 33959;
  else if (currentYear < 2028) return gender === "male" ?  38050 : 34324;
  else if (currentYear < 2029) return gender === "male" ?  38415 : 34689;
  else if (currentYear < 2030) return gender === "male" ?  38415 : 35054;
  else if (currentYear < 2031) return gender === "male" ?  38415 : 35419;
  else if (currentYear < 2032) return gender === "male" ?  38415 : 35784;
  else if (currentYear < 2033) return gender === "male" ?  38415 : 36149;
  else return gender === "male" ? 38415 : 36514;
};

export const getPointsPublic = (gender: GenderType, dateCurrent: Dayjs): number => {
  const date2022 = dayjs(new Date(2022, 3, 1));
  const date2023 = dayjs(new Date(2023, 6, 1));
  const date2024 = dayjs(new Date(2024, 9, 1));
  const date2026 = dayjs(new Date(2026, 0, 1));
  const date2027 = dayjs(new Date(2027, 3, 1));
  const date2028 = dayjs(new Date(2028, 6, 1));
  const date2029 = dayjs(new Date(2029, 9, 1));
  const date2031 = dayjs(new Date(2031, 0, 1));
  const date2032 = dayjs(new Date(2032, 3, 1));
  const date2033 = dayjs(new Date(2033, 6, 1));
  const date2034 = dayjs(new Date(2034, 9, 1));
  const date2036 = dayjs(new Date(2036, 0, 1));
  const date2037 = dayjs(new Date(2037, 3, 1));
  const date2038 = dayjs(new Date(2038, 6, 1));

  if (dateCurrent.isBefore(date2022)) return gender === "male" ? 35405 : 31404;
  else if (dateCurrent.isBefore(date2023)) return gender === "male" ? 35860 : 31859;
  else if (dateCurrent.isBefore(date2024)) return gender === "male" ? 36315 : 32314;
  else if (dateCurrent.isBefore(date2026)) return gender === "male" ? 36770 : 32769;
  else if (dateCurrent.isBefore(date2027)) return gender === "male" ? 37225 : 33224;
  else if (dateCurrent.isBefore(date2028)) return gender === "male" ? 37680 : 33679;
  else if (dateCurrent.isBefore(date2029)) return gender === "male" ? 38135 : 34134;
  else if (dateCurrent.isBefore(date2031)) return gender === "male" ? 38590 : 34589;
  else if (dateCurrent.isBefore(date2032)) return gender === "male" ? 39045 : 35044;
  else if (dateCurrent.isBefore(date2033)) return gender === "male" ? 39045 : 35499;
  else if (dateCurrent.isBefore(date2034)) return gender === "male" ? 39045 : 35954;
  else if (dateCurrent.isBefore(date2036)) return gender === "male" ? 39045 : 36409;
  else if (dateCurrent.isBefore(date2037)) return gender === "male" ? 39045 : 36864;
  else if (dateCurrent.isBefore(date2038)) return gender === "male" ? 39045 : 37319;
  else return gender === "male" ? 39045 : 37774;
};

export const getPercentualContribution = (
  gender: GenderType,
  minTime: MinDays,
  percentage: number,
  base: number,
  timeContribytion: Days
): number => {
  const percentual =
    gender === "male"
      ? (timeContribytion / 365 - minTime.male) * percentage + base
      : (timeContribytion / 365 - minTime.female) * percentage + base;
  return percentual > 100 ? 100 : percentual;
};



export const getMinAgeTime = (
  gender: GenderType,
  currentYear: number
): Days => {
  switch (currentYear) {
    case 2019:
      return gender === "male" ? periodToDays(61, 0) : periodToDays(56, 0);
    case 2020:
      return gender === "male" ? periodToDays(61, 6) : periodToDays(56, 6);
    case 2021:
      return gender === "male" ? periodToDays(62, 0) : periodToDays(57, 0);
    case 2022:
      return gender === "male" ? periodToDays(62, 6) : periodToDays(57, 6);
    case 2023:
      return gender === "male" ? periodToDays(63, 0) : periodToDays(58, 0);
    case 2024:
      return gender === "male" ? periodToDays(63, 6) : periodToDays(58, 6);
    case 2025:
      return gender === "male" ? periodToDays(64, 0) : periodToDays(59, 0);
    case 2026:
      return gender === "male" ? periodToDays(64, 6) : periodToDays(59, 6);
    case 2027:
      return gender === "male" ? periodToDays(65, 0) : periodToDays(60, 0);
    case 2028:
      return gender === "male" ? periodToDays(65, 0) : periodToDays(60, 6);
    case 2029:
      return gender === "male" ? periodToDays(65, 0) : periodToDays(61, 0);
    case 2030:
      return gender === "male" ? periodToDays(65, 0) : periodToDays(61, 6);
    default:
      return gender === "male" ? periodToDays(65, 0) : periodToDays(62, 0);
  }
};

export const getMinAgeTimePublic = (
  gender: GenderType,
  currentYear: number
): Days => {
  if (currentYear < 2022)
    return gender === "male" ? periodToDays(61, 0) : periodToDays(55, 0);
  else
    return gender === "male" ? periodToDays(62, 0) : periodToDays(56, 0);
};

export const getMinContributionTime = (
  gender: GenderType
): number => {
  return  gender === "male"
    ? periodToDays(35, 0)
    : periodToDays(30, 0);
};

export const getMinAgeTimeTool = (
  gender: GenderType
): number => {
  return  gender === "male"
    ? periodToDays(60, 0)
    : periodToDays(55, 0);
};
